module.exports = __webpack_public_path__ + "static/media/address-d-red-icon.0305ff91.svg";